<template>
    <span
        v-tooltip="'Ustawienia'"
        class="dropdown ml-2 pl-1 d-flex"
        :class="{ show: showUserLinks }"
        v-click-outside="hideUserLinks"
    >
        <button
            @click="toggleMenu"
            class="p-0 btn btn-link"
            type="button"
            id="userNav"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
        >
            <div class="d-flex position-relative  m-userControl__userSettings">
                <a-icon
                    class="ml-0"
                    width="26px"
                    height="26px"
                    :class="{ 'invisible position-absolute': showUserLinks }"
                    icon="UserAvatarMenuOpened"
                />

                <a-icon
                    class="ml-0"
                    width="26px"
                    height="26px"
                    :class="{ 'invisible position-absolute': !showUserLinks }"
                    icon="UserAvatarMenuHidden"
                />
            </div>
        </button>
        <transition name="slide">
            <div
                v-if="showUserLinks"
                class="menu-dropdown dropdown-responsive dropdown-menu dropdown-menu-right"
                :class="{ show: showUserLinks }"
                aria-labelledby="userNav"
            >
                <ul class="navbar-nav flex-column">
                    <li
                        class="nav-item"
                        :class="navLink.additionalClass"
                        v-for="(navLink, idx) in userNav"
                        :key="idx"
                    >
                        <router-link
                            class="nav-link"
                            :class="{ disable: navLink.disabled }"
                            :event="!navLink.disabled ? 'click' : ''"
                            :to="navLink.route"
                            @click.native="onUserLinkClick(navLink)"
                        >
                            <div class="nav-link__icon">
                                <a-icon
                                    :width="`${navLink.iconSize || 24}px`"
                                    :icon="navLink.icon"
                                />
                            </div>
                            <span>{{ navLink.text }}</span>
                        </router-link>
                    </li>
                    <router-link
                        class="nav-item border-top"
                        to="/logout"
                        tag="li"
                    >
                        <a class="nav-link" @click="hideUserLinks">
                            <a-icon icon="Logout" />
                            <span class="text-dark">Wyloguj się</span>
                        </a>
                    </router-link>
                </ul>
            </div>
        </transition>
    </span>
</template>

<script>
export default {
    data() {
        return {
            showUserLinks: false
        }
    },
    methods: {
        onUserLinkClick(navLink) {
            !navLink.disabled && this.hideUserLinks()
        },
        hideUserLinks() {
            if (this.showUserLinks) {
                this.showUserLinks = false
            }
        },
        toggleMenu() {
            this.showUserLinks = !this.showUserLinks
            if (window.innerWidth < 992) {
                this.$store.dispatch('toggleMobileMenu', false)
            }
        }
    },
    computed: {
        userNav() {
            return this.$store.getters.getUserNav
        }
    }
}
</script>

<style lang="scss" scoped>
.nav-link {
    display: flex;
    align-items: center;

    &.disable {
        opacity: 0.5;
    }

    &__icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 24px;
    }

    .a-icon {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
